import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, Renderer2, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';

import { cloneDeep } from 'lodash';

import { assetUrl } from '../../../asset-url';
import { PostEditDialogComponent } from '../../../components/post-edit-dialog/post-edit-dialog.component';
import { Comment, Post } from '../../../interfaces/post.interface';
import { CollaborationService } from '../../../services/collaboration.service';
import { User } from '../../../interfaces/space.interface';
import { LikedUsersDialogComponent } from '../../../components/liked-users-dialog/liked-users-dialog.component';
import { UserDetailsDialogComponent } from '../../../components/user-details-dialog/user-details-dialog.component';
import { UserThumbNailComponent } from '../../../components/user-thumb-nail/user-thumb-nail.component';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { NgClass, DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { QuillRTEComponent } from '../../../components/quill-rte/quill-rte.component';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { AssetUrlPipe } from '../../../pipes/asset-url.pipe';
@Component({
    selector: 'app-shared-post-details',
    templateUrl: './shared-post-details.component.html',
    styleUrl: './shared-post-details.component.scss',
    imports: [UserThumbNailComponent, MatMenuTrigger, MatMenu, MatMenuItem, NgClass, MatIcon, QuillRTEComponent, SpinnerComponent, DatePipe, AssetUrlPipe]
})
export class SharedPostDetailsComponent implements OnChanges, OnInit {

  @Input() post!: Post;
  @Input() isPostDetailView: boolean = false;
  @Input() atMentionConfig: any;
  @Output() sharedCommentEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  menuList: any = [];
  menuItem: any = '';
  commentMenuList: any = [];
  commentMenuItem: any = '';
  loggedInUser!: User;
  actionMenuList = [
    {
      name: "Details",
      imgUrl: "",
      icon: "info_outline",
      menuItemClasses: "details-icon",
    },
    // {
    //   name: "Star",
    //   imgUrl: "star",
    // },
    // 
    {
      name: "Edit",
      imgUrl: "pencil",
    }
  ];
  subscribeActions = {
    subscribe: {
      name: "Follow",
      imgUrl: "bell",
    },
    unsubscribe: {
      name: "UnFollow",
      imgUrl: "bell_cross",
      menuItemClasses: "icon-green"
    }
  }
  previewElement: any;
  createObjectURL!: string;
  showLoader: boolean = false;

  constructor(public dialog: MatDialog, private elementRef: ElementRef,
    private renderer: Renderer2, private collaborationService: CollaborationService,
    public sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.loggedInUser = this.collaborationService.allPostSpaceDetails.user;
  }

  openActions(post: Post) {
    if (post.createdById == this.loggedInUser.id) {
      this.menuList = this.isPostDetailView ? [this.actionMenuList[1]] : this.actionMenuList;
    }
    else {
      this.menuList = [
        this.actionMenuList[0],
        // post.followed ? this.subscribeActions.unsubscribe : this.subscribeActions.subscribe
      ];
    }

  }

  editCommentFunction(post: Post, message: string): any {
    const updatedPost = cloneDeep(post);
    updatedPost.text = message;
    return updatedPost;
  }

  ngOnChanges() {
    this.pullAllNecessaryDOMElements();
  }

  pullAllNecessaryDOMElements() {
    setTimeout(() => {
      this.getElements();
    })
  }

  getElements() {
    const elements = this.elementRef.nativeElement.getElementsByClassName('at-mention-span');
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      this.renderer.listen(element, 'click', () => {
        this.handleElementClick(element);
      });
    }
  }

  openUserDetailsDialog(data: any) {
    return;
    this.dialog.open(UserDetailsDialogComponent, {
      data: {
        ...data,
        //profilePictureUrl: await lastValueFrom(this.collaborationService.getUserProfilePicture(data.createdByEmail)) 
        profilePictureUrl: assetUrl('images/user.svg')
      },
      minWidth: '45vw',
      autoFocus: false
    });
  }

  handleElementClick(element: any) {
    const className: string[] = element.classList[1].split("--");
    if (className[0].includes("at-mention-id")) {
      this.openUserDetailsDialog({
        createdByName: className[1],
        createdByEmail: className[1]
      },);
    } else {
      const lastPart = className[0]?.split('-').pop();
      let [blobId, kind] = lastPart ? lastPart.split('**') : [];
      let docName = element.innerText;
      let lastDotIndex = docName?.lastIndexOf('.');
      let extension = docName.substring(lastDotIndex + 1);
      this.sharedCommentEventEmitter.emit({
        action: 'Download Document', data: {
          blobId,
          fileExtension: extension,
          kind,
          name: docName,
        }
      });
    }
  }

  editPost(post: Post) {
    const dialogRef = this.dialog.open(PostEditDialogComponent, {
      data: post,
      autoFocus: false,
      width: '45vw',
      panelClass: 'shared-edit-dialog'
    });
    dialogRef.afterClosed().subscribe((res: { text: string, id: string }) => {
      if (res && post.text !== res.text) {
        this.sharedCommentEventEmitter.emit({ action: 'Edit Post', data: { ...post, text: res.text } });
      }
    });
  }

  actionMenu(itemName: string, post: Post, index = -1) {
    switch (itemName) {
      case "Edit": this.editPost(post);
        break;
      case "Details": this.sharedCommentEventEmitter.emit({ action: 'Details', data: post });
        break;
      case "Follow": this.followOrUnFollow(post);
        break;
      case "UnFollow": this.followOrUnFollow(post);
        break;
    }
  }

  likeFunction(post: Post | Comment): any {
    const updatedPost = cloneDeep(post);
    updatedPost.numberOfLikes = updatedPost.currentUserLiked ? updatedPost.numberOfLikes - 1 : updatedPost.numberOfLikes + 1;
    updatedPost.currentUserLiked = !updatedPost.currentUserLiked;
    return updatedPost;
  }

  likePostOrCommentFunction(item: any, type?: string) {
    this.sharedCommentEventEmitter.emit({
      action: type ? 'Like Comment' : 'Like Post',
      data: item
    })
  }

  commentFunction(post: Post) {
    post.openCommentBox = !post.openCommentBox;
  }
  trackItemById(index: number, item: Post): any {
    return item.postId; // Assuming items have a unique "postId" property
  }

  trackItemByCommentId(index: number, item: Comment): any {
    return item.commentId; // Assuming items have a unique "postId" property
  }

  openCommentActions(comment: Comment) {
    if (comment.createdById == this.loggedInUser.id)
      this.commentMenuList = [this.actionMenuList[1]]
    else
      this.commentMenuList = [this.actionMenuList[1]]
  }

  editComment(comment: Comment, post: Post) {
    const dialogRef = this.dialog.open(PostEditDialogComponent, {
      data: { ...comment, isComment: true },
      autoFocus: false,
      width: '45vw',
      panelClass: 'shared-edit-dialog'
    });
    dialogRef.afterClosed().subscribe((res: { text: string, id: string }) => {
      if (res && comment.text !== res.text) {
        this.sharedCommentEventEmitter.emit({
          action: 'Edit Comment',
          data: {
            comment: { ...comment, text: res.text },
            post
          }
        })
      }
    });
  }

  commentActionMenu(itemName: string, comment: Comment, post: Post) {
    if (itemName == "Edit") {
      this.editComment(comment, post)
    }
  }

  openLikedUsersDialog(data: Post | Comment, isPost: boolean) {
    const users = (data.likedByUsers || []).map((user: any) => {
      user.profilePictureUrl = assetUrl('images/user.svg');
      return user;
    });

    this.dialog.open(LikedUsersDialogComponent, {
      data: {
        isPost: isPost,
        users: users // Directly use the updated users array
      },
      autoFocus: false,
      minWidth: '45vw',
      disableClose: true
    });
  }

  addComment(data: { text: string, id: string }, post: Post) {
    this.sharedCommentEventEmitter.emit({
      action: 'Add Comment',
      data: {
        comment: { text: data.text },
        post
      }
    })
  }

  followOrUnFollow(post: Post) {

  }
}
